import { observer } from 'mobx-react-lite'
import { GetServerSideProps } from 'next'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { CDNImage } from '~/components/business/CDNImage'
import { SEOHead } from '~/components/business/SEOHead'
import { GlobalRequest } from '~/components/global-requset'
import CreateDrawer from '~/components/pages/pro/danlu/CreateDrawer'
import RedeemCodeDrawer from '~/components/pages/pro/danlu/RedeemCodeDrawer'
import { MyBtn } from '~/components/ui/MyBtn'
import { MyContainer } from '~/components/ui/MyContainer'
import { MyIcon } from '~/components/ui/MyIcon'
import { GET_GPU_LIST } from '~/graphqls/gqls'
import {
  getGpuList,
  getGpuList_itemModule_productItemPage_edges_node_ProductItem,
  SystemCode,
} from '~/graphqls/types'
import { useValidateAuth } from '~/hooks/useValidateAuth'
import { Layout } from '~/layouts/default'
import { getGraphData } from '~/utils'

interface Props {
  gpuList: getGpuList_itemModule_productItemPage_edges_node_ProductItem[]
}

const AiPro = ({ gpuList }: Props) => {
  const [createVisible, setCreateVisible] = useState(false)
  const [redeemCodeVisible, setRedeemCodeVisible] = useState(false)
  const { validateIsLogin } = useValidateAuth()
  const router = useRouter()

  return (
    <Layout>
      <SEOHead title="AI 创作专业版" />
      <MyContainer>
        <div className="font-semibold flex items-center justify-between mb-[28px]">
          <div className="text-neutral-500 text-[22px] leading-[32px]">
            无界AI专业版
          </div>
          <div className="flex items-center">
            <MyBtn
              className="mr-3"
              $dark
              onClick={() => {
                if (validateIsLogin()) {
                  router.push('/pro/danlu')
                }
              }}
            >
              <MyIcon
                icon="danlu"
                className="mr-2 text-[20px] leading-5 align-middle"
              />
              我的丹炉
            </MyBtn>
            <MyBtn
              $dark
              className="mr-3"
              onClick={() => {
                if (validateIsLogin()) {
                  router.push('/pro/disk')
                }
              }}
            >
              <MyIcon
                icon="netdisk"
                className="mr-2 text-[20px] leading-5 align-middle"
              />
              我的网盘
            </MyBtn>
            <MyBtn
              $dark
              className="mr-3"
              onClick={() => {
                if (validateIsLogin()) {
                  router.push('/pro/order')
                }
              }}
            >
              <MyIcon
                icon="document"
                className="mr-2 text-[20px] leading-5 align-middle"
              />
              我的订单
            </MyBtn>
            <MyBtn
              $dark
              onClick={() => window.open('https://support.wujieai.com', '_blank')}
            >
              <MyIcon
                icon="compass"
                className="mr-2 text-[20px] leading-5 align-middle"
              />
              使用说明
            </MyBtn>
          </div>
        </div>
        {/* 模块1 */}
        <section className="flex justify-between items-center mb-24">
          <div className="w-[554px] px-[72px]">
            <div className="text-[40px] leading-[48px] font-semibold text-neutral-900 mb-4">
              <div>一键配置环境</div>
              <div>轻松玩转 AI 作画</div>
            </div>
            <div className="text-sm text-neutral-900 mb-12">
              告别环境搭建的繁琐流程，创建丹炉一键开启web
              UI，沉浸于AI作画的乐趣中
            </div>
            <div>
              <MyBtn
                type="primary"
                className="w-[150px] !bg-[#FFD600] !border-[#FFD600] !text-neutral-100 hover:opacity-80"
                onClick={() => {
                  if (validateIsLogin()) {
                    setRedeemCodeVisible(true)
                  }
                }}
              >
                免费体验
              </MyBtn>
              <MyBtn
                type="primary"
                className="w-[150px] ml-4"
                onClick={() => {
                  if (validateIsLogin()) {
                    setCreateVisible(true)
                  }
                }}
              >
                新建丹炉
              </MyBtn>
            </div>
          </div>
          <div className="w-[550px]">
            <CDNImage
              src="/images/pro/module-1@2x.png"
              className="rounded-2xl overflow-hidden"
            />
          </div>
        </section>
        {/* 模块2 */}
        <section className="flex justify-between items-center mb-24">
          <div className="w-[550px]">
            <CDNImage
              src="/images/pro/module-2@2x.png"
              className="rounded-2xl overflow-hidden"
            />
          </div>
          <div className="w-[554px] px-[72px]">
            <div className="text-[40px] leading-[48px] font-semibold text-neutral-900 mb-4">
              <div>能力强大</div>
              <div>模型训练不在话下</div>
            </div>
            <div className="text-sm text-neutral-900 mb-12">
              依托专业级显卡的强大算力和海量的预置模型，无界AI专业版是你训练模型的最佳选择
            </div>
            <div>
              <MyBtn
                type="primary"
                className="w-[150px] !bg-[#FFD600] !border-[#FFD600] !text-neutral-100 hover:opacity-80"
                onClick={() => {
                  if (validateIsLogin()) {
                    setRedeemCodeVisible(true)
                  }
                }}
              >
                免费体验
              </MyBtn>
              <MyBtn
                type="primary"
                className="w-[150px] ml-4"
                onClick={() => {
                  if (validateIsLogin()) {
                    setCreateVisible(true)
                  }
                }}
              >
                新建丹炉
              </MyBtn>
            </div>
          </div>
        </section>
        {/* 模块3 */}
        <section className="flex justify-between items-center mb-24">
          <div className="w-[554px] px-[72px]">
            <div className="text-[40px] leading-[48px] font-semibold text-neutral-900 mb-4">
              <div>云端存储</div>
              <div>免费容量等你用</div>
            </div>
            <div className="text-sm text-neutral-900 mb-12">
              创建丹炉即刻获得50GB网盘容量，AI创作自动同步至网盘，无需配置随心用
            </div>
            <div>
              <MyBtn
                type="primary"
                className="w-[150px]"
                onClick={() => {
                  if (validateIsLogin()) {
                    router.push('/pro/disk')
                  }
                }}
              >
                进入网盘
              </MyBtn>
            </div>
          </div>
          <div className="w-[550px]">
            <CDNImage
              src="/images/pro/module-3@2x.png"
              className="rounded-2xl overflow-hidden"
            />
          </div>
        </section>
      </MyContainer>
      {createVisible && (
        <CreateDrawer
          visible={createVisible}
          onClose={() => setCreateVisible(false)}
          gpuList={gpuList}
        />
      )}
      {redeemCodeVisible && (
        <RedeemCodeDrawer
          visible={redeemCodeVisible}
          onClose={() => setRedeemCodeVisible(false)}
        />
      )}
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { initialState, client } = await GlobalRequest(context)

  const [gpuListRes] = await Promise.all([
    client.query<getGpuList>({
      query: GET_GPU_LIST,
      fetchPolicy: 'no-cache',
      context: {
        headers: {
          system_code: SystemCode.WUJIE_AI,
        },
      },
    }),
  ])

  return {
    props: {
      initialState,
      gpuList: getGraphData(
        gpuListRes.data.itemModule?.productItemPage?.edges || []
      ),
    },
  }
}

export default observer(AiPro)
